import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "modal-backdrop" }
const _hoisted_2 = { class: "modal-card" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { value: null }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "col" }
const _hoisted_21 = { class: "mb-3" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col" }
const _hoisted_25 = { class: "mb-3" }
const _hoisted_26 = { class: "col" }
const _hoisted_27 = { class: "mb-3" }
const _hoisted_28 = { class: "col" }
const _hoisted_29 = { class: "mb-3" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col" }
const _hoisted_32 = { class: "mb-3" }
const _hoisted_33 = { class: "modal-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[26] || (_cache[26] = _createElementVNode("div", { class: "modal-header" }, [
        _createElementVNode("h3", null, "Add new blade model")
      ], -1)),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Loading..."))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.errorMsg)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.errorMsg), 1))
              : _createCommentVNode("", true),
            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "modal-section-title" }, [
              _createElementVNode("h5", null, "New blade model config"),
              _createElementVNode("p", null, "Information that is required for a turbine model")
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label" }, "Model name", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.model_name) = $event)),
                    class: "form-control",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.form.model_name]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-label" }, "Length (m)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.length) = $event)),
                    class: "form-control",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.form.length]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-label" }, "Blade designer", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.designer_id) = $event)),
                    class: "form-select",
                    onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.loadTurbineModelsForDesigner && _ctx.loadTurbineModelsForDesigner(...args)))
                  }, [
                    _cache[14] || (_cache[14] = _createElementVNode("option", { value: null }, "Select designer", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.design_companies, (company) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: company.company_id,
                        value: company.company_id
                      }, _toDisplayString(company.name), 9, _hoisted_14))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.form.designer_id]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", { class: "form-label" }, "Blade model", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.model_id) = $event)),
                    class: "form-select",
                    disabled: !_ctx.form.designer_id
                  }, [
                    _createElementVNode("option", _hoisted_18, _toDisplayString(_ctx.form.designer_id ? "Select model" : "Select blade designer first"), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.turbineModels, (model) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: model.turbine_model_id,
                        value: model.turbine_model_id
                      }, _toDisplayString(model.model), 9, _hoisted_19))
                    }), 128))
                  ], 8, _hoisted_17), [
                    [_vModelSelect, _ctx.form.model_id]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", { class: "form-label" }, "Blade manufacturer", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.manufacturer) = $event)),
                    class: "form-select"
                  }, [
                    _cache[17] || (_cache[17] = _createElementVNode("option", { value: null }, "Select manufacturer", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.manufacturing_companies, (company) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: company.company_id,
                        value: company.company_id
                      }, _toDisplayString(company.name), 9, _hoisted_22))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.form.manufacturer]
                  ])
                ])
              ])
            ]),
            _cache[24] || (_cache[24] = _createElementVNode("hr", null, null, -1)),
            _cache[25] || (_cache[25] = _createElementVNode("p", null, "Additional information for blade model configuration", -1)),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _cache[19] || (_cache[19] = _createElementVNode("label", { class: "form-label" }, "Release year", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.release_year) = $event)),
                    class: "form-control",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.form.release_year]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _cache[20] || (_cache[20] = _createElementVNode("label", { class: "form-label" }, "Matrix", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.matrix) = $event)),
                    class: "form-control",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.form.matrix]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", { class: "form-label" }, "pitch control type", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.pitch_control_type) = $event)),
                    class: "form-control",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.form.pitch_control_type]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", { class: "form-label" }, "Root retention method", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.root_retention_method) = $event)),
                    class: "form-control",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, _ctx.form.root_retention_method]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("button", {
                class: "btn btn-secondary",
                type: "button",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
              }, "Cancel"),
              _createElementVNode("button", {
                class: "btn btn-primary",
                type: "button",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
              }, "Save")
            ])
          ]))
    ])
  ]))
}